import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import {getMyContributionCount} from "root/DataFunctions/PostDataFns";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {dashboardDefaults, defaultTitleFontSize} from "root/dashboard/DashboardDefault";

const DashboardPanelUserPosts = (props) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;
	const [ dataPoints, setDataPoints ] = useState ( [] ) ;

	useEffect(() =>
	{
		getServerData() ;
	}, []);

    const generateChartData = ( item ) =>
	{
		return [
			{ y: +item.count, label: item.status, color: 'darkred'  },
		]
	}

	const getServerData = () => {

		getMyContributionCount( 'user',  (response) =>
		{
			if ( getNumRowsFromResponse(response) > 0 )
			{
				const rec = getDataFromResponse(response)[0];

				const chartData = generateChartData ( rec )  ;

				setDataPoints( chartData ) ;
				setData ( { loading: false, data : response.data }) ;
			}
			else
			{
				setData ( { loading: false, data : [] }) ;
			}
		});
	};

	const formPanel = () =>
	{
		const options = {
			animationEnabled: true,
			height: props.height,
			...dashboardDefaults,
			title: {
				text: props.title,
				fontSize: defaultTitleFontSize
			},
			data: [
				{
					type: "column",
					indexLabelFontSize: 10,
					indexLabel: "{label} - #percent%",
					dataPoints: dataPoints
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ getPanelHeader({ title: props.title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartPostsToApprove' options={options} uniqueId='chartPostsToApprove' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelUserPosts;

DashboardPanelUserPosts.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}